import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './style.scss'

const ColorBar = ({ label, index, progress, extraClasses, isVertical }) => {
  return (
    <div className={classnames('fil-color-bar grid-x align-middle', extraClasses)}>
      {label && (
        <label className={!isVertical ? 'cell fil-color-bar__label text-left' : 'cell fil-color-bar__label-vertical text-right'}>
          {label}
        </label>
      )}
      <div className="fil-color-bar__color-bar cell auto">
        <div
          className={classnames('fil-color-bar__color-bar-fill', `color-index-${index}`)}
          style={{
            width: progress
          }}
        />
      </div>
    </div>
  )
}

ColorBar.propTypes = {
  progress: PropTypes.string.isRequired,
  label: PropTypes.string,
  extraClasses: PropTypes.string,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isVertical: PropTypes.bool
}

ColorBar.defaultProps = {
  label: '',
  extraClasses: '',
  index: 0,
  isVertical: false
}

export default ColorBar
